import {
  UNIT,
  SIGN_OUT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function unit(state = initialState, action) {
  switch (action.type) {
    case UNIT.handlers.fetch:
    case UNIT.handlers.update:
      return {
        ...state,
        handling: true,
      };
    case UNIT.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
